<template>
    <form @submit.prevent="onSubmit" @keydown="form.errors.clear()">
        <input type="text" class="form-control" v-bind:id="element.id + '-edit-categoryname'"
               v-model="form.name">
        <input class="form-check-input"
               type="checkbox"
               v-bind:id="element.id + '-enabled-checkbox'"
               true-value="1"
               false-value="0"
               v-model="form.enabled">
        <label class="form-check-label" v-bind:for="element.id + '-enabled-checkbox'">
            Aktiv
        </label>
        <p class="form-text text-danger"  v-text="form.errors.get('name')"></p>
        <button type="submit" class="btn btn-primary btn-sm">Update</button>
    </form>
</template>

<script>

export default {
    name: "EditCategoryForm",

    data() {
        return {
            form: new Form(this.element)
        };
    },
    props: {
        element: {}
    },
    methods: {
        onSubmit(){
            this.form.put('/categories/' + this.element.id + '/edit')
                .then(category =>  this.$emit('updateCategory', category))
        }
    }
}
</script>

<style scoped>

</style>
